export default __webpack_public_path__ + "static/media/head_talking_vp9.1f99cc28.webm";